if (!customElements.get('aur-fixado-levarja-painel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.aur-artigo-mo');
      this.productForm = this.productSection.querySelector('aur-artigo-formulario2');
      this.atcButton = this.querySelector('.aur-bo-levarja-gatilho');
      this.productFormAtcButton = this.productForm.querySelector('.aur-bo-juntar-bano-sacola');

      if (this.productFormAtcButton) {
        this.productFormAtcButton.setAttribute('data-connected-button', '.aur-bo-levarja-gatilho');
      }

      this.bindEvents();
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      this.atcButton.removeEventListener('click', this.atcClickHandler);
    }

    bindEvents() {
      if (this.hasAttribute('data-show-on-scroll')) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.productForm && !theme.mediaMatches.md) {
              this.classList.toggle('aur-fixado-levarja-painel--ro', entry.boundingClientRect.bottom > 0);
            } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
              this.classList.toggle('aur-fixado-levarja-painel--ro', entry.isIntersecting);
            }
          });
        });

        if (this.productForm) observer.observe(this.productForm);
        if (this.productInfo) observer.observe(this.productInfo);

        window.addEventListener('scroll', StickyAtcPanel.handleScroll);
      }

      this.atcClickHandler = this.atcClickHandler || this.handleAtcClick.bind(this);
      this.atcButton.addEventListener('click', this.atcClickHandler);

      // Grab the currently selected swatch
      const stickyAtcVariantSwatch = this.querySelector('.aur-bo-levarja-eleito-versao-amostra');
      const activeSwatch = document.querySelector('.aur-artigo-central .aur-pe-le:checked + .aur-pe-rotulo--amostra');
      if (stickyAtcVariantSwatch && activeSwatch) {
        stickyAtcVariantSwatch.innerHTML = activeSwatch.outerHTML;
      }
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'aur-tevu-bano-fundo3',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }

    /**
     * Handle the click of the atc button
     */
    handleAtcClick() {
      if (this.productFormAtcButton) this.productFormAtcButton.click();
    }

    /**
     * Handle use as part of video testimonials
     */
    videoTestimonialsOpened() {
      this.classList.add('aur-fixado-levarja-painel--paso-pi');
      this.videoTestimonialsVariantClickHandler = () => {
        document.querySelector('aur-filme-nuzi[open]').close();
      };
      this.querySelector('a[href="#variants"]').addEventListener('click', this.videoTestimonialsVariantClickHandler);
    }

    /**
     * Reset to normal visibility
     */
    videoTestimonialsClosed() {
      this.classList.remove('aur-fixado-levarja-painel--paso-pi');
      this.querySelector('a[href="#variants"]').removeEventListener('click', this.videoTestimonialsVariantClickHandler);
    }
  }

  customElements.define('aur-fixado-levarja-painel', StickyAtcPanel);
}
